//최상위 메인 컴포넌트
import { BrowserRouter } from 'react-router';

import { MainLayout } from '../shared/components/Layout/MainLayout';

import { AppRoutes } from './AppRoutes';
import { AppProviders } from './providers/AppProviders';

function App() {
  return (
    <BrowserRouter>
      <AppProviders>
        <MainLayout>
          <AppRoutes />
        </MainLayout>
      </AppProviders>
    </BrowserRouter>
  );
}

export default App;
